import React, { useRef } from "react";
import { Box, Button, Typography } from "@mui/material";
import DownloadOutlined from "@mui/icons-material/DownloadOutlined";
import { QRCodeSVG } from "qrcode.react";

const MemberQrCode = ({ membershipId }) => {
  const qrRef = useRef(null);

  if (!membershipId) {
    return (
      <Typography color="text.secondary">
        A membership ID is required to generate this QR code.
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: 2,
          p: 2,
          display: "inline-flex",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
        }}
        ref={qrRef}
      >
        <QRCodeSVG
          value={String(membershipId)}
          size={240}
          level="M"
          includeMargin
          aria-label={`QR code for membership ID ${membershipId}`}
        />
      </Box>
      <Typography variant="body2" color="text.secondary" align="center">
        Membership ID: {membershipId}
      </Typography>
      <Button
        variant="contained"
        startIcon={<DownloadOutlined />}
        onClick={() => {
          const svg = qrRef.current?.querySelector("svg");
          if (!svg) return;

          const serializedSvg = new XMLSerializer().serializeToString(svg);
          const svgBlob = new Blob([serializedSvg], { type: "image/svg+xml;charset=utf-8" });
          const svgUrl = URL.createObjectURL(svgBlob);
          const image = new Image();

          image.onload = () => {
            const canvas = document.createElement("canvas");
            const padding = 32;
            canvas.width = image.width + padding * 2;
            canvas.height = image.height + padding * 2;
            const context = canvas.getContext("2d");
            context.fillStyle = "#ffffff";
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.drawImage(image, padding, padding);
            URL.revokeObjectURL(svgUrl);

            const link = document.createElement("a");
            link.download = `${String(membershipId).replace(/[^a-zA-Z0-9_-]/g, "_")}.png`;
            link.href = canvas.toDataURL("image/png");
            link.click();
          };

          image.src = svgUrl;
        }}
      >
        Download QR
      </Button>
    </Box>
  );
};

export default MemberQrCode;
